const ITEMS = [
    "Canecas",
    "Cestas",
    "Kits",
    "Camisetas",
    "Dry Fit",
    "Moletons",
    "Azulejos",
    "Chaveiros",
    "Garrafas",
    "Copos",
    "Brindes",
    "Formaturas",
];

const Sequence = ({ hidden }) => (
    <div className="flex items-center shrink-0" aria-hidden={hidden}>
        {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
                <span className="font-accent text-sm sm:text-base tracking-[0.3em] uppercase text-cream/85 px-7 sm:px-10">
                    {item}
                </span>
                <span className="w-1.5 h-1.5 rotate-45 bg-gold shrink-0" />
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <div
            data-testid="brand-marquee"
            className="marquee-wrap relative bg-obsidian py-5 overflow-hidden border-y border-gold/25"
        >
            <div className="flex w-max animate-marquee">
                <Sequence />
                <Sequence hidden />
            </div>
        </div>
    );
}
